import React from "react";
import PropTypes from "prop-types";
import { Controller } from "react-hook-form";
import { TextInput, PhoneInput, ToggleSwitch, NumericInput, PercentageInput } from "@/components/inputs";

/**
 * CoBorrowerFields — form field grid used inside CoBorrowerModal.
 * Extracted to keep co-borrower-modal.jsx under the 100-line limit.
 */
export default function CoBorrowerFields({ control, errors }) {
  return (
    <div className="grid grid-cols-4 gap-x-4 gap-y-4">
      <div className="col-span-4 sm:col-span-2">
        <Controller name="firstName" control={control} render={({ field }) => (
          <TextInput placeholder="First Name *" value={field.value} onChange={field.onChange} error={errors?.firstName?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="lastName" control={control} render={({ field }) => (
          <TextInput placeholder="Last Name *" value={field.value} onChange={field.onChange} error={errors?.lastName?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="email" control={control} render={({ field }) => (
          <TextInput placeholder="Email *" value={field.value} onChange={field.onChange} error={errors?.email?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="phoneNumber" control={control} render={({ field }) => (
          <PhoneInput placeholder="Phone Number" value={field.value} onChange={field.onChange} error={errors?.phoneNumber?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-2">
        <Controller name="mobileNumber" control={control} render={({ field }) => (
          <PhoneInput placeholder="Mobile Number" value={field.value} onChange={field.onChange} error={errors?.mobileNumber?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="ficoScore" control={control} render={({ field }) => (
          <NumericInput placeholder="FICO *" value={field.value} onChange={field.onChange} min={300} max={850} format="n0" error={errors?.ficoScore?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="liquidity" control={control} render={({ field }) => (
          <NumericInput placeholder="Liquidity *" value={field.value} onChange={field.onChange} format="c0" currency="USD" min={0} error={errors?.liquidity?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="netWorth" control={control} render={({ field }) => (
          <NumericInput placeholder="Net Worth" value={field.value} onChange={field.onChange} format="c0" currency="USD" error={errors?.netWorth?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="ownershipPercentage" control={control} render={({ field }) => (
          <PercentageInput placeholder="Ownership %" value={field.value} onChange={field.onChange} error={errors?.ownershipPercentage?.message} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="hasBeenBankruptcy" control={control} render={({ field }) => (
          <ToggleSwitch label="Bankruptcy?" checked={field.value ?? false} onChange={field.onChange} />
        )} />
      </div>
      <div className="col-span-4 sm:col-span-1">
        <Controller name="isUsCitizen" control={control} render={({ field }) => (
          <ToggleSwitch label="US Citizen?" checked={field.value ?? true} onChange={field.onChange} />
        )} />
      </div>
    </div>
  );
}

CoBorrowerFields.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
};

